<template>
   <div class="mycontent">
     <div class="cont">
       <div>展览信息</div>
       <p><img src="../assets/images/guide/mum.png" alt=""><span>{{Mydata.tourDetailInfo&&Mydata.tourDetailInfo.museumName}}</span></p>
       <p><img src="../assets/images/guide/zhanl.png" alt=""><span>{{Mydata.tourDetailInfo&&Mydata.tourDetailInfo.name}}</span></p>
       <p><img src="../assets/images/guide/key.png" alt=""><span class="maBtn" v-for="aa in Mydata.tourDetailInfo&&Mydata.tourDetailInfo.label.split(',')">{{aa}}</span></p>
       <p><img src="../assets/images/guide/tour1.png" alt=""><span>{{Mydata.tourDetailInfo&&Mydata.tourDetailInfo.tourTime}}</span></p>
       <p><img src="../assets/images/guide/tour2.png" alt=""><span>{{Mydata.tourDetailInfo&&Mydata.tourDetailInfo.address}}</span></p>
     </div>
     <div class="cont1">
       <div>简介</div>
       <p>{{Mydata.tourDetailInfo&&Mydata.tourDetailInfo.introduction}}</p>
     </div>
   </div>
</template>

<script>
    export default {
        name: "tabdetail",
      data(){
          return{

          }
      },
      props:{
        Mydata:Object
      }
    }
</script>

<style scoped lang="less">
.mycontent{
  clear: both;
  .title{
    height:2rem;
    padding: .5rem 0;
    margin-bottom: .5rem;
    span:nth-child(1){
      width:0.19rem;
      height:0.65rem;
      background:rgba(72,165,255,1);
      display:block;
      float: left;
      margin-top: .175rem;
    }
    span:nth-child(2){
      font-size:0.7rem;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(40,40,40,1);
      line-height:1rem;
      vertical-align: top;
      margin-left: 1rem;
    }
  }
  .cont{
    margin: 0 auto;
    width:16.25rem;
    height:8.3rem;
    background:rgba(241,241,242,1);
    border-radius:0.4rem;
    padding: 0.5rem;
    div{
      width:3.2rem;
      height:1.1rem;
      font-size:0.8rem;
      font-family:PingFang-SC-Bold;
      font-weight:bold;
      color:rgba(196,77,65,1);
      line-height:1.1rem;
      margin-bottom: 0.5rem;
    }
    img{
      width: 0.7rem;
      height: 0.7rem;
      transform: translateY(0.1rem);
    }
    p{
      width:16.25rem;
      font-size:0.7rem;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:1rem;
      margin-left: 0.5rem;
      margin-bottom: 0.35rem;
    }
    span{
      font-size:0.7rem;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:1rem;
      vertical-align: top;
      margin-left: .65rem;
    }
    .maBtn{
      height:1.05rem;
      font-size:0.65rem;
      font-family:PingFang-SC-Regular;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:1.05rem;
      border-radius:0.6rem;
      padding: .05rem .5rem;
      border:0.05rem solid #979797;
    }
  }
  .cont1{
    width:16.25rem;
    background:rgba(241,241,242,1);
    border-radius:0.4rem;
    padding: 0.5rem;
    margin: 0.5rem auto 0;
    div{
      width:1.6rem;
      height:1.1rem;
      font-size:0.8rem;
      font-family:PingFang-SC-Bold;
      font-weight:bold;
      color:rgba(196,77,65,1);
      line-height:1.1rem;
    }
    p{
      margin: 0.5rem 0 0 0.5rem;
      width:15.25rem;
      font-size:0.7rem;
      font-family:PingFang-SC-Regular;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:1.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/tabdetail.vue